import React from 'react';
import {
  Link,
  useRouteMatch,
  useLocation, Route, Redirect, Switch,
} from 'react-router-dom';
import Tabs from './Tabs';
import { Tab } from '../types';

/*
const tabs = [
  {
    label: 'My tab',
    route: 'my-tab',
    component: MyTab,
  },
];
 */

interface Props {
  tabs: Tab[],
  currentTabRoute: string,
  setCurrentTabRoute: (route: string) => void,
  tabProps?: any,
  tabsProps?: any,
  componentProps?: any,
  asCard?: boolean,
}

function StateTabs({
  tabs,
  tabProps,
  tabsProps,
  asCard,
  componentProps,
  currentTabRoute,
  setCurrentTabRoute,
}: Props) {
  const _tabs = tabs.map(({
    label,
    route
  }) => ({
    key: label,
    label,
    value: route,
    onClick: () => setCurrentTabRoute(route),
    ...tabProps,
  }));

  const currentTab = tabs.find((tab) => tab.route === currentTabRoute);

  if (!currentTab) return null;

  const Component = currentTab.component;

  return (
    <Tabs
      tabs={_tabs}
      tabsProps={{
        ...tabsProps,
        value: currentTabRoute,
      }}
      asCard={asCard}
    >
      <Component key={currentTab.label} {...componentProps} {...currentTab} />
    </Tabs>
  );
}

export default StateTabs;
